module.exports = "pegasus_template/assets/basic-image-text-header-preview.png";